import { isMatch, format } from 'date-fns';
import { useState, useEffect } from 'react';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TextField from '@mui/material/TextField';
import FormHelpText from './form-helpText';
import FormHelperText from '@mui/material/FormHelperText';

const FormInputDate = ({ item, unique, submitted }) => {
  const [value, setValue] = useState(null);
  const [error, setError] = useState(false);

  const validate = (val) => {
    try {
      // DatePicker will return a utc, test if we can reformat first
      const date = format(new Date(val), 'MM/dd/yyyy');
      const notValid = item.required && !isMatch(date, 'MM/dd/yyyy');
      if (notValid) {
        setError(true);
      } else if (item.validation) {
        const regex = new RegExp(item.validation);
        if (!regex.test(date)) {
          setError(true);
        }
      } else {
        setError(false);
      }
    } catch (error) {
      console.error(error);
      setError(true);
    }
  };

  const handleOnAccept = (date) => {
    setValue(date);
    setError(false);
  };

  useEffect(() => {
    if (submitted) {
      validate(value);
    }
  });

  return (
    <>
      <FormGroup className="tw-py-4">
        <InputLabel className="tw-font-normal tw-text-[#42474a] tra-text-web-body-m">{`${
          item.title
        }${item.required ? ' *' : ''}`}</InputLabel>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            inputFormat="MM/dd/yyyy"
            id={`form-${unique}`}
            name={unique}
            title={unique}
            value={value}
            required={item.required}
            renderInput={(props) => (
              <TextField
                {...props}
                variant="outlined"
                title={`${item.title}${item.required ? ' *' : ''}`}
                FormHelperTextProps={{
                  className: 'tw-mt-1',
                }}
                onBlur={(e) => validate(e.target.value)}
                InputProps={{
                  ...props.InputProps,
                  style: {
                    backgroundColor: '#ffffff',
                    boxShadow: error ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)` : '',
                    '&.Mui-focused': {
                      boxShadow: error
                        ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)`
                        : '0px 0px 0px 3px rgba(217, 94, 22, 0.4)',
                    },
                    '&.MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ecedee',
                    },
                  },
                  endAdornment: (
                    <>
                      {props.InputProps.endAdornment}
                      <InputAdornment className="tw-ml-6" position="end">
                        {error ? (
                          <CancelIcon color="error" />
                        ) : value === null ? (
                          ''
                        ) : (
                          <CheckCircleIcon color="primary" />
                        )}
                      </InputAdornment>
                    </>
                  ),
                }}
              />
            )}
            onChange={(date) => setValue(date)}
            onAccept={(date) => handleOnAccept(date)}
          />
        </LocalizationProvider>
        <FormHelperText>
          {error
            ? item.validationMessage
              ? item.validationMessage
              : `${item.title} is required`
            : ''}
        </FormHelperText>
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />
      </FormGroup>
    </>
  );
};
export default FormInputDate;
